import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface PrefilledSummaryState {
  show: boolean | null
  ruleId: number | null
  setShow: (show: boolean) => void
  setRuleId: (id: number) => void
}

const initialState: Omit<PrefilledSummaryState, 'setShow' | 'setRuleId'> = {
  show: null,
  ruleId: null
}

export const usePrefilledSummaryStore = create<PrefilledSummaryState>()(
  devtools(
    (set) => ({
      ...initialState,
      setShow(show) {
        set({ show }, false, 'setShow')
      },
      setRuleId(ruleId) {
        set({ ruleId }, false, 'setRuleId')
      }
    }),
    { name: 'usePrefilledSummaryStore' }
  )
)
